import { render, staticRenderFns } from "./teacherCourseWare.vue?vue&type=template&id=77a5442f&scoped=true"
import script from "./teacherCourseWare.vue?vue&type=script&lang=js"
export * from "./teacherCourseWare.vue?vue&type=script&lang=js"
import style0 from "./teacherCourseWare.vue?vue&type=style&index=0&id=77a5442f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a5442f",
  null
  
)

export default component.exports